import React, { Component } from 'react'
import styles from './styles.module.css'

const CONTACT_EMAIL = 'geral@solmarlimpezas.com'

class AskQuote extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      contact: '',
      message: '',
      errors: {},
    }
    this.handleChangeName = this.handleChangeName.bind(this)
    this.handleChangeContact = this.handleChangeContact.bind(this)
    this.handleChangeMessage = this.handleChangeMessage.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleChangeName({ target: { value } }) {
    this.setState({ name: value })
  }
  handleChangeContact({ target: { value } }) {
    this.setState({ contact: value })
  }
  handleChangeMessage({ target: { value } }) {
    this.setState({ message: value })
  }

  handleSubmit(e) {
    e.preventDefault()
    const errors = this.validateMessage()
    if (Object.keys(errors).length > 0) return

    const { name, contact, message } = this.state
    const { serviceName } = this.props

    const subjectParts = ['Pedido de Orçamento']
    if (serviceName) subjectParts.push(`- ${serviceName}`)
    subjectParts.push('| Solmar Limpezas')
    const subject = encodeURIComponent(subjectParts.join(' '))

    const sep = '────────────────────────────────────────'
    const bodyLines = [
      'PEDIDO DE ORÇAMENTO',
      sep,
      '',
      'Bom dia,',
      '',
      'Gostaria de solicitar mais informações ou orçamento.',
      '',
      sep,
      'DADOS DO CONTACTO',
      sep,
      '',
      `  Nome:    ${name.trim()}`,
      `  Contacto: ${contact.trim()}`,
      ...(serviceName ? [`  Serviço:  ${serviceName}`] : []),
      '',
      sep,
      'MENSAGEM',
      sep,
      '',
      message.trim().replace(/^/gm, '  '),
      '',
      sep,
      'Enviado através do site www.solmarlimpezas.com',
    ]
    const body = encodeURIComponent(bodyLines.join('\r\n'))

    window.location.href = `mailto:${CONTACT_EMAIL}?subject=${subject}&body=${body}`
  }

  validateMessage() {
    const { name, contact, message } = this.state
    const errors = {}

    if (!name || name.trim() === '') {
      errors.name = 'Campo Obrigatório'
    }
    if (!contact || contact.trim() === '') {
      errors.contact = 'Campo Obrigatório'
    }
    if (!message || message.trim() === '') {
      errors.message = 'Campo Obrigatório'
    }

    this.setState({ errors })
    return errors
  }

  render() {
    return (
      <div className={styles.main}>
        <div className={styles.title}>{'Pedir Orçamento'}</div>
        <div className={styles.subtitle}>
          <div>
            {'Gostava pedir orçamento ou saber mais sobre este serviço?'}
          </div>
          <div>{'Envie-nos uma mensagem e entraremos em contacto!'}</div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <input
            className={this.state.errors.name && styles.inputWithError}
            type="text"
            value={this.state.name}
            onChange={this.handleChangeName}
            placeholder={'Insira o seu nome'}
          />

          <input
            className={this.state.errors.contact && styles.inputWithError}
            type="text"
            value={this.state.contact}
            onChange={this.handleChangeContact}
            placeholder={'Insira o seu telefone/email'}
          />

          <textarea
            className={this.state.errors.message && styles.inputWithError}
            value={this.state.message}
            onChange={this.handleChangeMessage}
            placeholder={'Insira a sua mensagem'}
          />

          <div className={styles.formSubmit}>
            <button type="submit">{'Enviar Mensagem'}</button>
          </div>
        </form>
      </div>
    )
  }
}

export default AskQuote
